import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import { Typography } from "components/Typography";

import { FlaggedAccounts } from "./components/FlaggedAccounts";
import { Transactions } from "./components/Transactions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export const WatchlistTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Box>
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab
          label="Pending Transactions"
          {...a11yProps(0)}
          sx={{ textTransform: "capitalize", paddingLeft: 0 }}
        />
        <Tab
          label="Flagged Accounts"
          {...a11yProps(1)}
          sx={{ textTransform: "capitalize", paddingLeft: 0 }}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Transactions />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <FlaggedAccounts />
      </TabPanel>
    </Box>
  );
};
